import { Component, inject, signal } from "@angular/core";
import { ROUTES } from "../../../../constants/routes";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { AccountPageWrapper } from "../../components/account-page-wrapper/account-page-wrapper";
import { AccountService } from "../../../../services/account.service";
import { ClientResponse } from "../../../../models/api-response.model";

type ConfirmEmailStatus = "loading" | "success" | "error";

@Component({
  selector: "app-confirm-email",
  imports: [RouterLink, AccountPageWrapper],
  templateUrl: "./confirm-email.html",
  styleUrl: "./confirm-email.scss"
})
export class ConfirmEmail {
  readonly routes = ROUTES;
  private readonly _route = inject(ActivatedRoute);
  private readonly _router = inject(Router);
  private readonly _accountService = inject(AccountService);

  readonly status = signal<ConfirmEmailStatus>("loading");
  readonly message = signal("");

  ngOnInit(): void {
    const userId = this._route.snapshot.paramMap.get("userId") ?? "";
    const emailToken = this._route.snapshot.paramMap.get("emailToken") ?? "";

    if (!userId || !emailToken) {
      this.status.set("error");
      this.message.set("Invalid email confirmation link.");
      return;
    }

    this._accountService.confirmEmail({ userId, emailToken }).subscribe((response: ClientResponse<void>) => {
      this.message.set(response.message || (response.isSuccess ? "Email confirmed successfully." : "Unable to confirm email."));
      this.status.set(response.isSuccess ? "success" : "error");

      if (response.isSuccess) {
        setTimeout(() => {
          void this._router.navigate([ROUTES.accountLogin.url]);
        }, 2500);
      }
    });
  }
}
